export const name = 'siteEditorContextService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-editor-context' as const
